var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Row, Container } from "reactstrap";
import Icon from "../../components/Icon";
import { InsuranceScopeWrapper, Col1, IconLargeWrapper, IconLargeBg, Col2, Header, IconSmallWrapper, StyledTitle, Description, List, ListItem, TickCircleIconWrapper, ListItemText } from "./InsuranceScope.styled";

var InsuranceScope = function InsuranceScope(_a) {
  var title = _a.title,
      description = _a.description,
      items = _a.items,
      icon = _a.icon,
      bg = _a.bg,
      iconBg = _a.iconBg,
      isReversed = _a.isReversed,
      anchor = _a.anchor,
      props = __rest(_a, ["title", "description", "items", "icon", "bg", "iconBg", "isReversed", "anchor"]);

  return React.createElement(InsuranceScopeWrapper, __assign({
    id: anchor,
    bg: bg
  }, props), React.createElement(Container, null, React.createElement(Row, null, React.createElement(Col1, {
    xs: {
      size: 12,
      offset: 0
    },
    sm: !isReversed ? {
      size: 2,
      offset: 1
    } : {
      size: 2,
      offset: 1,
      order: 2
    }
  }, React.createElement(IconLargeWrapper, null, React.createElement(IconLargeBg, {
    iconBg: iconBg
  }, React.createElement(Icon, {
    name: icon,
    width: "100%",
    height: "100%"
  })))), React.createElement(Col2, {
    xs: {
      size: 12,
      offset: 0
    },
    sm: {
      size: 7,
      offset: 1
    }
  }, React.createElement("div", null, React.createElement(Header, null, React.createElement(IconSmallWrapper, {
    iconBg: iconBg
  }, React.createElement(Icon, {
    name: icon
  })), React.createElement(StyledTitle, {
    bg: bg
  }, title)), React.createElement(Description, {
    bg: bg
  }, description), React.createElement(List, {
    bg: bg
  }, items.map(function (item) {
    return React.createElement(ListItem, null, React.createElement(TickCircleIconWrapper, null, React.createElement(Icon, {
      name: "TickCircle",
      width: 24,
      height: 24
    })), React.createElement(ListItemText, {
      bg: bg
    }, item));
  })))))));
};

export default InsuranceScope;